var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 24,
    height: 24,
    rx: 7.04587,
    fill: "#808080"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0539 16.1101C22.0539 19.515 19.2937 22.2752 15.8888 22.2752C12.4839 22.2752 9.72363 19.515 9.72363 16.1101C9.72363 12.7052 12.4839 9.94495 15.8888 9.94495C19.2937 9.94495 22.0539 12.7052 22.0539 16.1101ZM15.8888 20.7339C18.4425 20.7339 20.5126 18.6638 20.5126 16.1101C20.5126 13.5564 18.4425 11.4862 15.8888 11.4862C13.3351 11.4862 11.2649 13.5564 11.2649 16.1101C11.2649 18.6638 13.3351 20.7339 15.8888 20.7339Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4947 8.18347C22.9811 8.18347 23.3754 8.57778 23.3754 9.0642C23.3754 9.55062 22.9811 9.94493 22.4947 9.94493C22.0083 9.94493 21.614 9.55062 21.614 9.0642C21.614 8.57778 22.0083 8.18347 22.4947 8.18347ZM20.2929 9.0642C20.2929 10.2802 21.2787 11.266 22.4947 11.266C23.7107 11.266 24.6965 10.2802 24.6965 9.0642C24.6965 7.84816 23.7107 6.86237 22.4947 6.86237C21.2787 6.86237 20.2929 7.84816 20.2929 9.0642Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.e883d085bd8de3fd5f787d7c2d26ed8c.svg";
export { ForwardRef as ReactComponent };